import axios from "axios";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import Modal from "../../../Componentes/Utils/Modal";
import MultifileUploader from "../../../Componentes/Utils/MultiFileUploader";
import { useModal } from "../../../contexts/ModalContext";
import { useEffect, useState } from "react";
import ColabMultiSelector from "../../../Componentes/Utils/ColabMultiSelector";

const equipes = [
    "ALMOXERIFADO/MATERIAIS",
    "ANDAIMES",
    "APOIO OPERACIONAL",
    "CALDEIRARIA",
    "CONSTRUÇÃO CIVIL",
    "ELETRICA E INSTRUMENTAÇÃO",
    "IÇAMENTO E MOVIMENTAÇÃO DE CARGAS",
    "ISOLAMENTO TÉRMICO",
    "LOGÍSTICA E OPERAÇÃO",
    "MECÂNICA DE MANUTENÇÃO",
    "MECÂNICA",
    "QUALIDADE",
    "RESTAURANTE",
    "SERVIÇOS ADMINISTRATIVOS",
    "SERVIÇOS DE PINTURA",
    "SERVIÇOS GERAIS",
    "SOLDAGEM",
    "SSMA",
    "TUBULAÇÃO"
];

const ModalNovoDesvio = ({ idDesvio = null, mode = 'create', onSave }) => {

    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);

    const [optionsObras, setOptionsObras] = useState([]);
    const [optionsContratos, setOptionsContratos] = useState([]);
    const [optionsAreas, setOptionsAreas] = useState([]);
    const [optionsCategorias, setOptionsCategorias] = useState([]);
    const [tiposRiscos, setTiposRiscos] = useState([]);
    const [lideres, setLideres] = useState([]);

    const [anexos, setAnexos] = useState([]);
    const [colaboradores, setColaboradores] = useState([]);

    const initialRequest = async () => {

        try {

            const [obras, categoriasRes, lideresRes] = await Promise.all([
                axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasAtivas/'),
                axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/Categorias/'),
                axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/Lideres/')
            ]);

            setOptionsObras(obras.data.map(obra => (obra.OBRA)))
            setOptionsCategorias(categoriasRes.data);
            setLideres(lideresRes.data.map(
                lider => ({
                    value: lider.MATRICULA, label: lider.NOME
                })
            ));

        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }

    }

    const fetchInfo = async () => {

        setLoading(true);

        try {

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/DesvioInfo/', {
                id_desvio: idDesvio
            })

            console.log(data);

        } catch (e) {

            console.log(e);

        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        initialRequest();
        if (idDesvio) {
            fetchInfo();
        }

    }, [idDesvio]);

    const [formValues, setFormValues] = useState({
        centroCusto: '',
        contrato: '',
        dataOcorrido: '',
        area: '',
        equipe: '',
        processo: '',
        categoriaRisco: '',
        tipoRisco: '',
        atoCondicaoInsegura: '',
        ocorrencia: '',
        acaoCorretiva: '',
        liderImediato: '',
        classificacaoDesvio: '',
        acidente: '',
        jaFoiResolvido: ''
    })

    useEffect(() => {

        const fetchContratos = async () => {
            setLoading(true);

            try {
                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetContratosObra/', {
                    'centro_custo': formValues.centroCusto
                });
                setOptionsContratos(data.map(contrato => contrato.nome_contrato))
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        }

        setFormValues(prev => ({ ...prev, contrato: '' }))

        if (formValues.centroCusto !== '') {
            fetchContratos();
        } else {
            setOptionsContratos([]);
        }

    }, [formValues.centroCusto])

    useEffect(() => {

        const fetchCtiposRiscos = async () => {
            setLoading(true);

            try {
                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/TiposRiscosCat/', {
                    categoria: formValues.categoriaRisco
                })

                setTiposRiscos(data);
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        }

        setFormValues(prev => ({ ...prev, tipoRisco: '' }))

        if (formValues.categoriaRisco !== '') {
            fetchCtiposRiscos();
        } else {
            setTiposRiscos([]);
        }

    }, [formValues.categoriaRisco]);

    useEffect(() => {

        const riscoSelecionado = tiposRiscos.find(tipo => tipo.uuid === formValues.tipoRisco);

        setFormValues(prev => ({ ...prev, acidente: ''  }))

        if (riscoSelecionado) {
            setFormValues(prev => ({ ...prev, classificacaoDesvio: riscoSelecionado.classificacao }));
        } else {
            setFormValues(prev => ({ ...prev, classificacaoDesvio: '' }))
        }

    }, [formValues.tipoRisco]);

    useEffect(() => {

        const fetchAreas = async () => {
            setLoading(true);

            try {
                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/Areas/', {
                    'centro_custo': formValues.centroCusto,
                    'contrato': formValues.contrato
                });

                console.log(data);
                setOptionsAreas(data.map(area => ({ value: area.id, label: area.area })));
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        }

        setFormValues(prev => ({ ...prev, area: '' }))

        if (formValues.centroCusto !== "" && formValues.contrato !== "") {
            fetchAreas();
        } else {
            setOptionsAreas([]);
        }

    }, [formValues.contrato])

    useEffect(() => {

        console.log(anexos);

    }, [anexos])

    const [ saving, setSaving ] = useState(false);

    const submitForm = async (e) => {

        e.preventDefault();

        if( colaboradores.length === 0 ) {
            alert("Selecione ao menos um colaborador para o desvio.");
            return;
        }

        setSaving(true);

        try {

            const formData = new FormData();

            Object.entries(formValues).forEach(([key, value]) => {
                formData.append(key, value);
            })

            formData.append('colaboradores', JSON.stringify(colaboradores))

            anexos.forEach((f, index) => {
                formData.append(`files[${index}]`, f.file);
            })

            await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/SaveDesvio/', formData, {
                withCredentials: true
            })

            await onSave();
            closeModal();

        } catch (e) {

            console.log(e);

        }finally{

            setSaving(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} >
                    <Formulario onSubmit={(e) => submitForm(e)} >
                        <FormComp
                            title="CENTRO CUSTO"
                            type="select"
                            options={optionsObras}
                            valor={formValues.centroCusto}
                            changeFunc={(e) => setFormValues({ ...formValues, centroCusto: e.target.value })}
                            required
                        />
                        <FormComp
                            title="CONTRATO"
                            type="select"
                            options={optionsContratos}
                            valor={formValues.contrato}
                            changeFunc={(e) => setFormValues({ ...formValues, contrato: e.target.value })}
                            required
                        />
                        <FormComp
                            title="DATA DO OCORRIDO"
                            type="date"
                            valor={formValues.dataOcorrido}
                            changeFunc={(e) => setFormValues({ ...formValues, dataOcorrido: e.target.value })}
                            required
                        />
                        <FormComp
                            title="ÁREA"
                            type="select"
                            obj
                            options={optionsAreas}
                            valor={formValues.area}
                            changeFunc={(e) => setFormValues(prev => ({ ...prev, area: e.target.value }))}
                            required
                        />
                        <FormComp
                            title="EQUIPE"
                            type="select"
                            options={equipes}
                            valor={formValues.equipe}
                            changeFunc={(e) => setFormValues({ ...formValues, equipe: e.target.value })}
                            required
                        />
                        <FormComp
                            title="PROCESSO"
                            type="select"
                            obj
                            options={[
                                { value: "MEIO AMBIENTE", label: "MEIO AMBIENTE" },
                                { value: "SAUDE", label: "SAÚDE" },
                                { value: "SEGURANCA DO TRABALHO", label: "SEGURANÇA DO TRABALHO" }
                            ]}
                            valor={formValues.processo}
                            changeFunc={(e) => setFormValues({ ...formValues, processo: e.target.value })}
                            required
                        />
                        <FormComp
                            title="CATEGORIA DO RISCO"
                            type="select"
                            obj
                            options={
                                optionsCategorias.map(cat => ({ value: cat.uuid, label: cat.nome }))
                            }
                            valor={formValues.categoriaRisco}
                            changeFunc={(e) => setFormValues(prev => ({ ...prev, categoriaRisco: e.target.value }))}
                            required
                        />
                        <FormComp
                            title="TIPO DE RISCO"
                            type="select"
                            obj
                            options={
                                tiposRiscos.map(tipo => ({ value: tipo.uuid, label: tipo.tipo }))
                            }
                            valor={formValues.tipoRisco}
                            changeFunc={(e) => setFormValues({ ...formValues, tipoRisco: e.target.value })}
                            required
                        />
                        <FormComp
                            title="ATO OU CONDIÇÃO INSEGURA"
                            type="select"
                            obj
                            options={[
                                { value: "ATO", label: "ATO" },
                                { value: "CONDICAO", label: "CONDIÇÃO" }
                            ]}
                            valor={formValues.atoCondicaoInsegura}
                            changeFunc={(e) => setFormValues({ ...formValues, atoCondicaoInsegura: e.target.value })}
                            required
                        />
                        <FormComp
                            title="OCORRÊNCIA"
                            type="textarea"
                            valor={formValues.ocorrencia}
                            changeFunc={(e) => setFormValues({ ...formValues, ocorrencia: e.target.value })}
                            required
                        />
                        <FormComp
                            title="AÇÃO CORRETIVA"
                            type="textarea"
                            valor={formValues.acaoCorretiva}
                            changeFunc={(e) => setFormValues(prev => ({ ...prev, acaoCorretiva: e.target.value }))}
                        />
                        <ColabMultiSelector
                            colaboradores={colaboradores}
                            setColaboradores={setColaboradores}
                            required
                        />
                        <FormComp
                            title="LÍDER IMEDIATO"
                            type="select"
                            obj
                            options={ lideres }
                            valor={formValues.liderImediato}
                            changeFunc={(e) => setFormValues(prev => ({ ...prev, liderImediato: e.target.value }))}
                            required
                        />
                        <FormComp
                            title="CLASSIFICAÇÃO DO DESVIO"
                            type="select"
                            disabled
                            obj
                            options={[
                                { value: 1, label: "MODERADO" },
                                { value: 2, label: "ALTO" }
                            ]}
                            valor={formValues.classificacaoDesvio}
                            required
                        />
                        {
                            formValues.classificacaoDesvio === 2 && (
                                <FormComp
                                    title="STATUS ACIDENTE"
                                    type="select"
                                    options={["NENHUM", "INCIDENTE", "ACIDENTE"]}
                                    valor={formValues.acidente}
                                    changeFunc={(e) => setFormValues(prev => ({ ...prev, acidente: e.target.value }))}
                                    required
                                />
                            )
                        }
                        <FormComp
                            title="JÁ FOI RESOLVIDO?"
                            type="select"
                            obj
                            options={[
                                { value: 1, label: "SIM" },
                                { value: 0, label: "NÃO" }
                            ]}
                            valor={formValues.jaFoiResolvido}
                            changeFunc={(e) => setFormValues({ ...formValues, jaFoiResolvido: e.target.value })}
                            required
                        />
                        <MultifileUploader
                            files={anexos}
                            setFiles={setAnexos}
                        />
                        <FormComp
                            type="submit"
                            valor={ saving ? "SALVANDO..." : "SALVAR DESVIO" }
                            disabled={ saving }
                        />
                    </Formulario>
                    {
                        loading && (
                            <Overlay state={true} >
                                <Modal size="sm" >
                                    <SmallLoading />
                                </Modal>
                            </Overlay>
                        )
                    }
                    {
                        saving && (
                            <Overlay state={true} >
                                <Modal size="sm" >
                                    <SmallLoading text="SALVANDO INFORMAÇÕES DO DESVIO..." />
                                </Modal>
                            </Overlay>
                        )
                    }
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNovoDesvio;